



































import { Component, Prop, PropSync, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { orderBy } from 'lodash'
import { SortOrder, UserDetailStateInfo } from '@/types'

const COLS: Col[] = [
  {
    width: 40,
    items: [
      {
        name: 'descNo',
        align: 'right'
      }
    ]
  },
  {
    width: '100',
    items: [
      {
        name: 'keyword',
        headerText: 'キーワード',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 30,
    items: [
      {
        name: 'remove',
        align: 'center'
      }
    ]
  }
]

export interface UserNewArrivalNoticeKeywordTableItem {
  id: number
  keyword: {
    input: string
    errorMessage: string
  }
}

const defaultUserNewArrivalNoticeKeywordTableItem = (): UserNewArrivalNoticeKeywordTableItem => ({
  id: 0,
  keyword: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    DataTable
  }
})
export default class UserNewArrivalNoticeKeywordTable extends ComponentVue {
  @PropSync('items', {
    type: Array,
    required: true
  })
  inputItems!: UserNewArrivalNoticeKeywordTableItem[]

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get sortedInputItems(): UserNewArrivalNoticeKeywordTableItem[] {
    if (this.sortName) {
      return orderBy<UserNewArrivalNoticeKeywordTableItem>(
        this.inputItems,
        (item: UserNewArrivalNoticeKeywordTableItem) => {
          switch (this.sortName) {
            case 'keyword':
              return item.keyword.input
          }
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.inputItems
  }

  get allCols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return COLS.map(col => {
        return {
          width: col.width,
          items: col.items.map(item => {
            return {
              name: item.name,
              headerText: item.headerText,
              align: item.align,
              sortable: false,
              sortOrder: item.sortOrder,
              lineFeed: item.lineFeed
            }
          })
        }
      })
    }

    return COLS
  }

  get cols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return this.allCols
    }
    return this.allCols.filter((item: Col) => {
      return item.items[0].name !== 'remove'
    })
  }

  @Watch('state.state')
  onChangeState(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  add(): void {
    this.inputItems.unshift(defaultUserNewArrivalNoticeKeywordTableItem())
  }

  remove(index: number): void {
    this.inputItems.splice(index, 1)
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }
}
